import React, { useEffect, useRef, useState } from 'react';

export default function SearchBar({ value, onChange, placeholder = 'Search episodes…', debounceMs = 400 }) {
  const [local, setLocal] = useState(value || '');
  const onChangeRef = useRef(onChange);

  useEffect(() => setLocal(value || ''), [value]);

  useEffect(() => {
    onChangeRef.current = onChange;
  }, [onChange]);

  useEffect(() => {
    const t = setTimeout(() => {
      if (local !== value) onChangeRef.current(local);
    }, debounceMs);
    return () => clearTimeout(t);
  }, [local, value, debounceMs]);

  return (
    <input
      value={local}
      onChange={(e) => setLocal(e.target.value)}
      placeholder={placeholder}
      className="w-full rounded-lg border border-surface bg-background p-3 text-sm text-textSecondary placeholder:text-textMuted focus:outline-none focus:ring-1 focus:ring-primary"
    />
  );
}
